import { z } from "zod";
import { IsoDateTimeSchema, StableIdSchema } from "./common.js";

export const TaskPushDeliveryStatusSchema = z.enum([
  "delivery_unknown",
  "delivery_confirmed",
  "delivery_failed",
  "not_attempted",
]);

export const TaskPushRecordSchema = z
  .object({
    recordId: StableIdSchema,
    jobId: StableIdSchema,
    runId: StableIdSchema,
    jobName: z.string().min(1).max(160),
    channel: z.string().min(1).max(80),
    taskStatus: z.enum(["completed", "failed"]),
    deliveryStatus: TaskPushDeliveryStatusSchema,
    outputSummary: z.string().max(500),
    outputContent: z.string().max(200_000),
    startedAt: IsoDateTimeSchema.nullable(),
    completedAt: IsoDateTimeSchema,
    readAt: IsoDateTimeSchema.nullable(),
  })
  .strict();

export const TaskPushFeedSchema = z
  .object({
    records: z.array(TaskPushRecordSchema).max(200),
    unreadCount: z.number().int().nonnegative(),
    updatedAt: IsoDateTimeSchema,
  })
  .strict();

export const TaskPushMutationResponseSchema = z
  .object({
    updated: z.number().int().nonnegative(),
    updatedAt: IsoDateTimeSchema,
  })
  .strict();

export type TaskPushDeliveryStatus = z.infer<typeof TaskPushDeliveryStatusSchema>;
export type TaskPushRecord = z.infer<typeof TaskPushRecordSchema>;
export type TaskPushFeed = z.infer<typeof TaskPushFeedSchema>;
export type TaskPushMutationResponse = z.infer<typeof TaskPushMutationResponseSchema>;
